<div class="offer-tile">
  <table *ngIf="offers.length > 0" aria-label="List of offers" mat-table
         [dataSource]="selectedOffer== null ? offers : [selectedOffer]" class="offers-table"
         [class.single-offer]="true"
         cdkDropList
         [cdkDropListData]="offers"
  style="padding-left: 2rem;
  padding-right: 2rem">

    <ng-container matColumnDef="status">
      <th mat-header-cell *matHeaderCellDef class="text-start"> {{'offer.status'|translate}}</th>
      <td mat-cell class="text-start" *matCellDef="let offer">
        <div *ngIf="offer.offerType === OfferType.EXTERNAL_COVERAGE" class="offer-status-container external">
          <span>
            {{'offer.extern' |translate}}
          </span>
        </div>
        <div *ngIf="offer.offerType !== OfferType.EXTERNAL_COVERAGE" class="offer-status-container external">
          <span>
            {{'offer.open' |translate}}
          </span>
        </div>
      </td>
    </ng-container>
    <ng-container matColumnDef="creator">
      <th mat-header-cell *matHeaderCellDef class="text-start"> {{'offer.offerCreator'|translate}}</th>
      <td mat-cell class="text-start" *matCellDef="let offer">
        <div *ngIf="offer.offerType != OfferType.EXTERNAL_COVERAGE"
             class="d-flex all-cursor-pointer user-pod"
             (click)="navigateToUserProfile(offer.creator.id)">
          <img class="custom-profile-picture me-2 rounded-circle"
               [src]="(userService.getProfilePicture(offer.creator.id) |async) ?? 'assets/img/profile/default-profile-icon.png'"
               alt="private"/>
          <div class="d-flex flex-column justify-content-center">
              <span
                      class="light-text small-text creator-label">{{(this.user$|async).firstName}} {{(this.user$|async).lastName}}</span>
              <a [routerLink]="'/'+ Route.COMPANY_PROFILE+'/'+ (this.company$|async).companyId"
                 class="dark-text small-text company-label">{{(this.company$|async).name}}</a>
          </div>
        </div>
        <div *ngIf="offer.offerType === OfferType.EXTERNAL_COVERAGE" class="d-flex external">
          <div class="custom-profile-picture me-2 rounded-circle">{{'offer.ex'|translate}}</div>
          <span class="dark-text small-text">{{offer.externalInsurer.name}}</span>
        </div>
      </td>
    </ng-container>
    <ng-container matColumnDef="premium">
      <th mat-header-cell *matHeaderCellDef class="text-end"> {{'offer.expectedTotalPremiumWithoutSupercript'|translate}}</th>

      <td mat-cell class="text-end" *matCellDef="let offer">
        <div *ngIf="offer.offerType !== OfferType.REJECTION">
          {{offer.premium |currency:offer.currency}}
          ({{ offer.premium / insuredAmount |percentFormat}})
        </div>
        <div *ngIf="offer.offerType === OfferType.REJECTION"></div>
      </td>

    </ng-container>
    <ng-container matColumnDef="share">
      <th mat-header-cell *matHeaderCellDef class="text-end"> {{'offer.coverageShare'|translate}}</th>
      <td mat-cell class="text-end" *matCellDef="let offer">
        <div *ngIf="offer.offerType !== OfferType.REJECTION">
          {{NumberParseService.convertToPercentageDisplay(offer.amountCovered, 2)}}
        </div>
        <div *ngIf="offer.offerType === OfferType.REJECTION"></div>
      </td>
    </ng-container>
    <ng-container matColumnDef="role">
      <th mat-header-cell *matHeaderCellDef class="text-start"> {{'offer.role'|translate}}</th>

      <td mat-cell class="text-start" *matCellDef="let offer">
        <div *ngIf="offer.offerType !== OfferType.REJECTION">{{'offer.' + getRole(offer)|translate}}</div>
        <div *ngIf="offer.offerType === OfferType.REJECTION"></div>
      </td>
    </ng-container>
    <ng-container>
      <tr mat-row
        *matRowDef="let row; columns: (selectedOffer == null ? displayedColumns: displayedColumns.slice(0, displayedColumns.length-1));"
        cdkDrag
        [cdkDragData]="row"
        [cdkDragDisabled]="(proposalUserId$|async) != (activeUserId$|async)"
        cdkDragLockAxis="y">
      </tr>
    </ng-container>

  </table>
  <!--  Add space so the popover is not hidden by overflow-->

</div>
